import React, { useState, useEffect } from 'react';
import { useMutation, useLazyQuery } from '@apollo/client';
import { SELLERS_WITH_COUNT } from '../Sellers/queries';
import { MainContainer, ContentContainer } from '../../elements';
import styled from 'styled-components/native';
import DataState from 'app/src/components/DataState';
import { IMPORT_ASSETS } from './queries';
import {
  View, Text, SafeAreaView, FlatList, Pressable, Switch
} from 'react-native';
import { ButtonContainer } from './elements';
import { ButtonGroup, Button } from '../../elements/buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';

import { elRed, elGray } from 'app/src/styles/colors';
import StockNumberCard from '../../elements/StockNumberCard';
import { Link } from 'app/src/utils/routing';
import Modal from 'app/src/elements/Modal';

import AssignToUsers from './AssignToUsers';
import Unimported from './Unimported';

const InputContainer = styled(View)`
  display: flex;
  width: 25%;
`;

const StockNumbersContainer = styled(View)`
  background-color: ${elGray};
  border: 1px solid black;
  border-radius: 5px;
  width: 100%;
  min-width: 50%;
  min-height: 200px;
  height: fit-content;
`;

const flatListContainer = {
  flex: 1,
  justifyContent: 'center',
  backgroundColor: elGray
}

export const ColumnContainer = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const LeftContainer = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  margin-right: 20px;
  border-radius: 5px;
  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const RightContainer = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  border-radius: 5px;
  height: 80vh;
  @media (max-width: 600px) {
    height: 60px;
  }
`;

const FailedStockNumbers = styled(View)`
  background-color: ${elGray};
  border: 1px solid black;
  border-radius: 5px;
  width: 100%;
  height: fit-content;
  margin-bottom: 20px;
  padding: 10px;
`;

const FoundStockNumbers = styled(FailedStockNumbers)`
`;

const AssetsImport = () => {
  const [sellers, setSellers] = useState([]);
  const [sellerId, setSellerId] = useState();
  const [showOnWeb, setShowOnWeb] = useState(false);
  const [typedStockNum, setTypedStockNum] = useState('');
  const [stockNumbers, setStockNumbers] = useState([]);
  const [foundStockNumbers, setFoundStockNumbers] = useState([]);
  const [notFoundStockNumbers, setNotFoundStockNumbers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedSellerUsers, setSelectedSellerUsers] = useState([]);
  const [showUnusedModal, setShowUnusedModal] = useState(false);
  const [submitting, setSubmitting] = useState();

  const [ loadSellers, { loading: loading, data: data } ] =
    useLazyQuery(SELLERS_WITH_COUNT, {
      onCompleted: () => setSellers(data?.sellersWithCount?.entries)
    }
  );

  const [importAssets] = useMutation(IMPORT_ASSETS, {
    onCompleted: (response) => {
      setSubmitting(false);
      setStockNumbers([]);
      setFoundStockNumbers(response.importAssets.assets);
      setNotFoundStockNumbers(response.importAssets.notFoundStockNumbers);
    }
  });

  useEffect(() => {
    loadSellers();
  }, []);

  const showUnused = () => setShowUnusedModal(true);

  const handleSubmit = () => {
    setSubmitting(true);
    importAssets({
      variables: {
        sellerId,
        showOnWeb,
        stockNumbers,
        userIds: selectedUsers,
        sellerUserIds: selectedSellerUsers
      }
    });
    setSubmitting(false)
  };

  return (
    <MainContainer>
      <ContentContainer>
        <ColumnContainer>
          <LeftContainer>
            <View>
              <Text>Seller:</Text>
              <select
                label=""
                name="sellerId"
                options={sellers}
                onChange={(e) => setSellerId(e.target.value)}
              >
                <option key="seller-nil" value="">Select Seller</option>
                {sellers?.map(seller =>
                  <option
                    key={`seller${seller.id}`}
                    value={seller.id}
                  >
                    {seller.name}
                  </option>
                )}
              </select>

              <View style={{ flexDirection: 'row', marginTop: 12, gap: 12 }}>
                <Text>Launch on Imported Assets on Buyer Website?</Text>
                <Switch
                  value={showOnWeb}
                  onValueChange={() => setShowOnWeb(!showOnWeb)}
                />
              </View>
              <br />
              <View style={{flexDirection: 'row'}}>
                <View>
                  <Text>Add Stock Number:</Text>
                  <View style={{display: 'flex', flexDirection: 'row'}}>
                    <input
                      type="text"
                      value={typedStockNum}
                      onChange={(e) => setTypedStockNum(e.target.value)}
                    />
                    <FontAwesomeIcon
                      icon={faSquarePlus}
                      size='xl'
                      style={{color: elRed, marginLeft: '5px'}}
                      onClick={() => updateStockNumbers(typedStockNum, 'add')}
                    />
                  </View>
                </View>
                <View style={{marginLeft: 'auto'}}>
                  <Pressable onPress={showUnused}>
                    <Text>Show Unimported Stock Numbers</Text>
                  </Pressable>
                </View>
              </View>
            </View>
            <br />
            <Text>Stock Numbers To Be Imported:</Text>
            <StockNumbersContainer>
              {/* { stockNumbers.map(stockNumber =>
                <StockNumberCard
                  key={`stock-number-${Math.random() * 1000}`}
                  stockNumber={stockNumber}
                  updateStockNumbers={updateStockNumbers}
                />
              )} */}
              <SafeAreaView style={flatListContainer}>
                <FlatList
                  data={stockNumbers}
                  renderItem={({item}) => (
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'column',
                      }}>
                      <StockNumberCard
                        key={`stock-number-${Math.random() * 1000}`}
                        stockNumber={item}
                        updateStockNumbers={updateStockNumbers}
                      />
                    </View>
                  )}
                  //Setting the number of column
                  numColumns={5}
                  keyExtractor={(item, index) => index}
                />
              </SafeAreaView>
            </StockNumbersContainer>
            <br /><br />
            <Text>Assign to Users</Text>
            <AssignToUsers
              sellerId={sellerId}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              selectedSellerUsers={selectedSellerUsers}
              setSelectedSellerUsers={setSelectedSellerUsers}
            />
          </LeftContainer>
          <RightContainer>
            {foundStockNumbers.length > 0 &&
              <FoundStockNumbers>
                <Text>
                  The system added or updated the following stock numbers:
                </Text>
                <br />
                {foundStockNumbers.map(asset => (
                  <Link
                    to={`/sellers/${asset.seller.id}/assets/${asset.id}`}
                    key={asset.id}
                  >
                    <Text>
                      {asset.stockNumber}
                    </Text>
                  </Link>
                ))}
              </FoundStockNumbers>
            }
            {notFoundStockNumbers.length > 0 &&
              <FailedStockNumbers>
                <Text>
                  The system was unable to locate assets with the following
                  stock numbers:
                </Text>
                <br />
                {notFoundStockNumbers.map(stockNumber => (
                  <Text key={stockNumber}>{stockNumber}</Text>
                ))}
              </FailedStockNumbers>
            }
          </RightContainer>
        </ColumnContainer>
        {sellerId ? (
          <ButtonContainer>
            <ButtonGroup>
            {submitting ?
              DataState.Loading :
              <Button label="Import Assets" onPress={() => handleSubmit()} />
            }
            </ButtonGroup>
          </ButtonContainer>
        ) : (
          <Text style={{fontWeight: 600}}>Select seller to import</Text>
        )}
      </ContentContainer>
      {showUnusedModal && (
        <Modal
          showUnusedModal
          setShowModal={setShowUnusedModal}
          modalType="Unimported Stock Numbers on SOARR"
        >
          <Unimported
            stockNumbers={stockNumbers}
            updateStockNumbers={updateStockNumbers}
          />
        </Modal>
      )}
    </MainContainer>
  )

  function updateStockNumbers(stockNum, action) {
    let newStockNumbers = stockNumbers;
    if (!stockNum) { return; }
    if(action === 'add') {
      if (!stockNumbers.includes(stockNum)) {
        newStockNumbers = [...stockNumbers, stockNum];
      }
    }else {
      newStockNumbers = newStockNumbers.filter(sn => sn !== stockNum)
    }
    setStockNumbers(newStockNumbers);
    setTypedStockNum('');
  }
}

export default AssetsImport;
